export const API_RESPONSE = {
    SUCCESS: {
        PROCESSING_COMPLETE: 'Successfully Processed'
    },
    ERROR: {
        PROCESSING_FAILURE: 'Fail to Process'
    }
};

export const COURSE_PLAN_RESPONSES = {
    CONFIRMATION_POPUP: 'Confirmation Pop-Up',
    REQUEST_SUBMITTED_SUCCESSFULLY: 'Request submitted successfully',
    REQUEST_ALREADY_EXIST_FOR_ANOTHER_USER: 'Request already exists for another user',
    REQUEST_PUBLISHED_SUCCESSFULLY: 'Request published successfully',
};